export class ValidationError extends Error {}

const availablePrefixCodeOfStates = [
    61, 62, 64, 65, 66, 67, 82, 71, 73, 74, 75, 77, 85, 88, 98, 99, 83, 81,
    87, 86, 89, 84, 79, 68, 96, 92, 97, 91, 93, 94, 69, 95, 63, 27, 28, 31,
    32, 33, 34, 35, 37, 38, 21, 22, 24, 11, 12, 13, 14, 15, 16, 17, 18, 19,
    41, 42, 43, 44, 45, 46, 51, 53, 54, 55, 47, 48, 49,
];

export function validPhoneNumber(number: string, country = 'br') {
    if (country === 'br' && number.length < 12) {
        throw new ValidationError('Número inválido');
    }
    validNumberDDD(number);
}

export function validNumberDDD(phone: string) {
    const countryCode = phone.slice(0, 2);
  
    if (countryCode !== "55") {
        return;
    }
  
    const statePrefixCode = phone.slice(2, 4); 

    if (!availablePrefixCodeOfStates.includes(parseInt(statePrefixCode))) {
        throw new ValidationError('Prefixo inválido');
    }
}

export function validEmail(email: string) {
    const result = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/.test(email)
        && /^[a-zA-Z0-9._-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email)
        && !(/(@gamil|@\S+\.con|@\S+\.como)/).test(email);
    if (!result) {
        throw new ValidationError('Email inválido');
    }
}

export function validName(name: string) {
    if (name.length < 3) {
        throw new ValidationError('Nome deve ter no mínimo 3 caracteres');
    }
    if (name.length > 50) {
        throw new ValidationError('Nome deve ter no máximo 50 caracteres');
    }
    if (!/^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ'\s]+$/.test(name)) {
        throw new ValidationError('O nome deve conter apenas letras');
    }
    if ((/\s{2,}/).test(name)) {
        throw new ValidationError('Nome não pode conter dois espaços seguidos');
    }
}